export default __webpack_public_path__ + "static/bg-pag-interna.2742da36-3c328989de053cf5f09322d3d3b03f99.jpg";